import { makeStyles } from '@material-ui/core/styles';

export const useMessageStyles = makeStyles(() => ({
  container: {
    borderRadius: (props) => (props.fullRounded ? '4px' : null),
    marginTop: (props) => (props.mobile ? 10 : 15),
    width: '100%',
    padding: 12,
    boxSizing: 'border-box',
  },
  success: {
    border: '1px solid #007e2e',
    background: 'rgba(0,131,48,0.12)',
  },
  alert: {
    border: '1px solid #FFCC00',
    background: 'rgba(255,204,0,0.12)',
  },
  error: {
    border: '1px solid #EB0043',
    background: 'rgba(235,0,67,0.12)',
  },
  info: {
    border: '1px solid #5b73ba',
    background: 'rgba(91, 115, 186, 0.12)',
  },
  image: {
    width: 20,
    height: 20,
    marginRight: 12,
  },
  text: {
    fontSize: 16,
    color: '#1a1a1a',
  },
}));
